module.exports = __webpack_public_path__ + "img/65_M7_sea_levels.4f42689b.jpg";